function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useMemo, useState, useCallback, memo } from 'react';
import { useIntl } from 'react-intl';
import { getLoggedOutConfigList, DEFAULT_LOCALE, getLoggedOutFallbackLocales } from '@cbhq/intl';
import { GLOBAL_EDITION_CODE } from '../constants.js';
import { useDisplayDetails } from '../hooks/useDisplayDetails.js';
import messages from '../messages.js';
import { SCREEN_IDS } from '../useGlobalPreferenceNavigation.js';
import { isGlobalEdition } from '../utils/isGlobalEdition.js';
import CountrySelector from './CountrySelector.js';
import LanguageSelector from './LanguageSelector.js';
import MainScreen from './MainScreen.js';
import { jsx, Fragment } from 'react/jsx-runtime';
function GlobalPreferenceScreens({
  currentScreen,
  navigateTo,
  languageCode,
  countryCode: _countryCode,
  countryCodeFromIP,
  localeInformation,
  localeFromUrl
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;

  // If the country code is not supported or absent, we default to 'others'
  // which corresponds to the "rest of the world" entry
  const countryCode = useMemo(() => {
    return isGlobalEdition({
      countryFromUrl: _countryCode,
      languageCode,
      countryFromIp: countryCodeFromIP,
      localeFromUrl
    }) ? GLOBAL_EDITION_CODE : _countryCode;
  }, [_countryCode, countryCodeFromIP, languageCode, localeFromUrl]);

  // This list includes the countries from config + the "rest of the world" entry
  const configList = useMemo(() => {
    const countryConfig = getLoggedOutConfigList();
    return [...countryConfig, {
      country_code: GLOBAL_EDITION_CODE,
      country_name: formatMessage(messages.globalLabel),
      default_locale: DEFAULT_LOCALE,
      supported_locales: getFallbackLanguagesList(localeInformation)
    }];
  }, [formatMessage, localeInformation]);
  const _useState = useState(countryCode),
    _useState2 = _slicedToArray(_useState, 2),
    countryForLanguageSelector = _useState2[0],
    setCountryForLanguageSelector = _useState2[1];
  const _useDisplayDetails = useDisplayDetails(countryCode, languageCode, localeInformation.localeCodeToDisplayName, localeFromUrl),
    _useDisplayDetails$co = _useDisplayDetails.countryName,
    countryName = _useDisplayDetails$co === void 0 ? '' : _useDisplayDetails$co,
    _useDisplayDetails$la = _useDisplayDetails.languageName,
    languageName = _useDisplayDetails$la === void 0 ? '' : _useDisplayDetails$la;
  const goToCountryScreen = useCallback(() => {
    navigateTo(SCREEN_IDS.country);
  }, [navigateTo]);
  const goToLanguageScreen = useCallback(country => {
    setCountryForLanguageSelector(country);
    navigateTo(SCREEN_IDS.language);
  }, [navigateTo]);
  const Screens = useMemo(() => {
    switch (currentScreen.id) {
      case SCREEN_IDS.main:
        return /*#__PURE__*/jsx(MainScreen, {
          goToCountryScreen: goToCountryScreen,
          goToLanguageScreen: goToLanguageScreen,
          languageName: languageName,
          countryName: countryName,
          countryCode: countryCode
        });
      case SCREEN_IDS.country:
        return /*#__PURE__*/jsx(CountrySelector, {
          countries: configList,
          selectedCountryCode: countryCode,
          goToLanguageScreen: goToLanguageScreen
        });
      case SCREEN_IDS.language:
        return /*#__PURE__*/jsx(LanguageSelector, {
          countryCode: countryForLanguageSelector,
          countries: configList,
          localeInformation: localeInformation
        });
      default:
        return /*#__PURE__*/jsx(Fragment, {});
    }
  }, [currentScreen, goToCountryScreen, goToLanguageScreen, languageName, countryName, countryCode, configList, countryForLanguageSelector, localeInformation]);
  return Screens;
}
function getFallbackLanguagesList(localeInformation) {
  // The "Global" entry should have all the fallback language
  // ie. regions not part of loc-2.0 + English
  //
  // why English? For the case where user landing on coinbase.com/ from India

  return [DEFAULT_LOCALE, ...getLoggedOutFallbackLocales()].map(locale => {
    return {
      tag: locale,
      name: localeInformation.localeCodeToDisplayName[locale],
      code: locale
    };
  });
}
const GlobalPreferenceScreens$1 = /*#__PURE__*/memo(GlobalPreferenceScreens);
export { GlobalPreferenceScreens$1 as default };
//# sourceMappingURL=screens.js.map
